export function readData(dataView, offset, size) {
    const length = (size > 0) ? size : (dataView.byteLength - (offset - dataView.byteOffset));
    return new Uint8Array(dataView.buffer, offset, Math.max(length, 0));
}
;
//# sourceMappingURL=readData.js.map